module.exports = __webpack_public_path__ + "img/item4.e39b3914.png";